import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Icon, IconNames, Text, TextField } from '@dotcom/crown-ui';
import { useAnalyticsContext } from '../../../../context/analytics-context';
import { isLoggedIn } from '../../../../utils';
import { HeaderContentProps } from '../summary-drawer-types';
import styles from '../summary-drawer.module.scss';

export const HeaderContent = ({ projectName, onUpdateDraftName, isSaving }: HeaderContentProps): React.ReactElement => {
  const { trackEditProjectSummaryName } = useAnalyticsContext();
  const [isEditing, setIsEditing] = useState(false);
  const [draftName, setDraftName] = useState(projectName);
  const isLogged = isLoggedIn();

  type FormInputs = {
    draftName: string;
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>({
    defaultValues: { draftName: draftName },
  });

  const onSubmit = (data: FormInputs) => {
    setIsEditing(false);
    setDraftName(data.draftName);
    onUpdateDraftName(data.draftName, true);
  };

  const onEditClick = () => {
    setIsEditing(true);
    trackEditProjectSummaryName();
  };

  return (
    <div className={styles['header-wrapper']} data-testid="summary-header-wrapper">
      {isEditing && (
        <form className={styles['draft-name-form']} data-testid="summary-draft-form">
          <TextField
            className={styles['summary-input']}
            label="Draft name"
            placeholder=""
            domId="summaryDraftInputId"
            testId="summary-input"
            register={register('draftName', { required: 'Draft Name is required' })}
            helperText={errors.draftName ? errors.draftName.message : ''}
            isError={Boolean(errors.draftName)}
          />

          <Button
            className={styles['draft-name-submit-btn']}
            variant="secondary"
            size="icon"
            onClick={handleSubmit(onSubmit)}
            testId="draft-name-submit-btn"
          >
            <Icon name={IconNames.CheckDefault} size="22" color="purple" />
          </Button>
        </form>
      )}
      {!isEditing && (
        <>
          <div className={styles['draft-name-container']} data-testid="summary-draft-name-container">
            <Text as="span" color="textPrimary">
              {draftName}
            </Text>
          </div>
          <div>
            {isLogged && (
              <Button
                className={styles['draft-name-edit-btn']}
                variant="secondary"
                size="icon"
                onClick={onEditClick}
                disabled={isSaving}
                testId="draft-name-edit-btn"
              >
                <Icon name={IconNames.Edit} size="22" color="purple" />
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
};
